import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import {
  getAboutServ,
  updateAboutContentServ,
} from "../../services/about.service";

function AboutContent() {
  const editor = useRef(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const descriptionRef = useRef("");
  const [btnLoader, setBtnLoader] = useState(false);

  const config = {
    placeholder: "Write the About Us paragraph here...",
    height: "350px",
  };

  const getAboutFunc = async () => {
    try {
      const response = await getAboutServ();
      const data = response?.data?.data;
      if (data) {
        setTitle(data.title || "");
        setDescription(data.description || "");
        descriptionRef.current = data.description || "";
      }
    } catch (error) {
      toast.error("Failed to fetch About Us content");
    }
  };

  useEffect(() => {
    getAboutFunc();
  }, []);

  const handleUpdate = async () => {
    if (!title.trim()) {
      toast.warn("Title cannot be empty!");
      return;
    }
    setBtnLoader(true);
    try {
      const response = await updateAboutContentServ({
        title,
        description: descriptionRef.current,
      });
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message);
        getAboutFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="About Us Manager" selectedItem="About Content" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{ position: "relative", top: "-75px", marginBottom: "-75px" }}
          ></div>

          <div className="mt-3">
            <div className="card-body px-2">
              <div className="d-flex">
                <h4
                  className="p-2 text-dark shadow rounded mb-4"
                  style={{ background: "#05E2B5" }}
                >
                  About Us : Top Content
                </h4>
              </div>

              <div className="mb-3">
                <label className="fw-semibold mb-1">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="e.g. Discover the Story Behind Our Nutritious Makhana Brand"
                />
              </div>

              <div className="mb-3">
                <label className="fw-semibold mb-1">Description</label>
                <JoditEditor
                  ref={editor}
                  config={config}
                  value={description}
                  onChange={(newContent) => {
                    descriptionRef.current = newContent;
                  }}
                />
              </div>

              <button
                className="btn btn-primary w-100 mt-2"
                style={{
                  background: "#61ce70",
                  border: "none",
                  borderRadius: "24px",
                }}
                onClick={handleUpdate}
                disabled={btnLoader}
              >
                {btnLoader ? "Updating ..." : "Update Content"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutContent;
